import { useTranslator } from '@bluebeam/react-i18n';
import Close from 'components/Icons/Close';
import InvisibleEye from 'components/Icons/InvisibleEye';
import { MapboxStyles } from 'constants/map';
import satelliteImage from 'images/map-view-types/satellite.jpg';
import streetImage from 'images/map-view-types/street.jpg';
import React, { FC } from 'react';
import ToggleItem from './ToggleItem';

type ToggleMenuProps = {
  id?: string;
  closeMenu: VoidFunction;
  includeNoMap?: boolean;
  mapStyle: MapboxStyles;
  onStyleChange: (nextStyle: MapboxStyles) => void;
  style: React.CSSProperties;
};

const ToggleMenu: FC<ToggleMenuProps> = ({
  id,
  closeMenu,
  mapStyle,
  onStyleChange,
  includeNoMap = false,
  style,
}: ToggleMenuProps) => {
  const { translate } = useTranslator(['mapView']);

  return (
    <div
      className="pos-a map-toggle-menu bgd-light-grey-2 b-3"
      style={{
        height: '11rem',
        bottom: '92px',
        left: '78px',
        boxShadow: '0 2px 16px 0 rgba(0, 116, 204, 0.08)',
        ...style,
      }}
    >
      <div className="su-row items-center px3 justify-between my3">
        <p className="my0">{translate('mapView:toggleMenu.mapType')}</p>
        <span onClick={closeMenu}>
          <Close style={{ width: 8, height: 8, cursor: 'pointer' }} />
        </span>
      </div>
      <div className="su-row mx2">
        <ToggleItem
          id={`${id}-street`}
          name={translate('mapView:toggleMenu.street')}
          value={MapboxStyles.street}
          onClick={onStyleChange}
          mapStyle={mapStyle}
        >
          <img height={96} width={96} src={streetImage} alt="street view" />
        </ToggleItem>
        <ToggleItem
          id={`${id}-satellite`}
          name={translate('mapView:toggleMenu.satellite')}
          value={MapboxStyles.satellite}
          onClick={onStyleChange}
          mapStyle={mapStyle}
        >
          <img
            height={96}
            width={96}
            src={satelliteImage}
            alt="satellite view"
          />
        </ToggleItem>
        {includeNoMap && (
          <ToggleItem
            id={`${id}-none`}
            name={translate('mapView:toggleMenu.noMap')}
            value={MapboxStyles.none}
            onClick={onStyleChange}
            mapStyle={mapStyle}
          >
            <InvisibleEye />
          </ToggleItem>
        )}
      </div>
    </div>
  );
};

export default ToggleMenu;
